// Sistema de niveles/XP del Museo Virtual.
export const DISCOVERY_XP = 25;
export const MISSION_XP_BONUS = 50;
export const RESTORATION_XP = 40;
export const TEAM_BONUS_XP = 20;
export const XP_PER_LEVEL = 50;

const LEVEL_TIERS = [
  { minLevel: 1, name: 'Visitante' },
  { minLevel: 10, name: 'Explorador' },
  { minLevel: 20, name: 'Curador' },
  { minLevel: 40, name: 'Maestro del Museo' }
];

export const levelForXp = (xp) => Math.floor(Math.max(0, Number(xp) || 0) / XP_PER_LEVEL) + 1;

export const tierForLevel = (level) => {
  let tier = LEVEL_TIERS[0];
  for (const t of LEVEL_TIERS) {
    if (level >= t.minLevel) tier = t;
  }
  return tier;
};

export const xpProgressInLevel = (xp) => {
  const safeXp = Math.max(0, Number(xp) || 0);
  const current = safeXp % XP_PER_LEVEL;
  return { current, total: XP_PER_LEVEL, percent: Math.round((current / XP_PER_LEVEL) * 100) };
};

export const nextTier = (level) => LEVEL_TIERS.find((t) => t.minLevel > level) || null;
